import script from "./SWMA.vue?vue&type=script&lang=js"
export * from "./SWMA.vue?vue&type=script&lang=js"

const __exports__ = script;

export default __exports__